// TODO: implement
// ===============================================
// TRANSLATIONS - الترجمات المحدثة
// ===============================================
const translations = {
  ar: {
    pageTitle: "الخدمات الذاتية للموظفين",
    myDocuments: "مستنداتي",
    myDocumentsDesc: "عرض وإدارة وتحميل جميع مستندات العمل والعقود والشهادات",
    goToDocuments: "الذهاب إلى المستندات",
    solfaRequests: "طلبات السلفة",
    solfaRequestsDesc: "طلب سلفة على الراتب وتتبع طلبات السلف والدفعات النشطة",
    goToSolfa: "الذهاب إلى السلفة",
    storageOverview: "نظرة عامة على التخزين",
    usedStorage: "المساحة المستخدمة",
    totalFiles: "إجمالي الملفات",
    storageUsed: "المساحة المستخدمة",
    used: "مُستخدم",
    total: "الإجمالي",
    searchPlaceholder: "البحث في المستندات أو العلامات أو المحتوى...",
    requestDocument: "طلب مستند",
    upload: "رفع",
    allDocuments: "جميع المستندات",
    contracts: "العقود",
    payslips: "كشوف الرواتب",
    certificates: "الشهادات",
    policies: "السياسات",
    otherCategory: "أخرى",
    documents: "المستندات",
    myRequests: "طلباتي",
    noRequestsYet: "لا توجد طلبات مستندات بعد",
    requested: "مطلوب:",
    solfaOverview: "نظرة عامة على السلفة",
    totalRequests: "إجمالي الطلبات",
    totalRequested: "الإجمالي المطلوب",
    activeAdvances: "السلف النشطة",
    outstandingBalance: "الرصيد المستحق",
    requestAdvancement: "طلب سلفة",
    mySolfaRequests: "طلبات السلفة الخاصة بي",
    noSolfaYet: "لا توجد طلبات سلفة بعد",
    installments: "قسط",
    balance: "الرصيد:",
    uploadNewDocument: "رفع مستند جديد",
    dragDropFiles: "اسحب وأفلت الملفات هنا",
    orClickBrowse: "أو انقر لتصفح الملفات",
    browseFiles: "تصفح الملفات",
    documentType: "نوع المستند",
    contract: "عقد",
    payslip: "كشف راتب",
    certificate: "شهادة",
    policy: "سياسة",
    cancel: "إلغاء",
    close: "إغلاق",
    fileSize: "حجم الملف",
    format: "التنسيق",
    uploadDate: "تاريخ الرفع",
    status: "الحالة",
    tags: "العلامات",
    viewDocument: "عرض المستند",
    requestHRDocument: "طلب مستند من الموارد البشرية",
    selectDocumentType: "اختر نوع المستند",
    hrLetter: "خطاب الموارد البشرية",
    hrLetterDesc: "خطاب رسمي من الموارد البشرية يتضمن تفاصيل التوظيف",
    bankHRLetter: "خطاب الموارد البشرية للبنك",
    bankHRLetterDesc: "خطاب الموارد البشرية لأغراض البنك مع بند تحويل الراتب",
    salaryStatement: "كشف راتب",
    salaryStatementDesc: "كشف تفصيلي بالراتب والخصومات والبدلات الشهرية",
    experienceCertificate: "شهادة خبرة",
    experienceCertificateDesc: "شهادة رسمية تثبت فترة العمل والمسمى الوظيفي",
    vacationRequest: "طلب إجازة",
    vacationRequestDesc: "طلب إجازة رسمية مع تحديد المدة والنوع",
    otherDocument: "مستند آخر",
    otherDocumentDesc: "أي مستند آخر من الموارد البشرية",
    documentDetails: "تفاصيل المستند المطلوب",
    documentDetailsPlaceholder: "اكتب تفاصيل المستند الذي تحتاجه بالتفصيل...",
    recipient: "المرسل إليه",
    recipientPlaceholder: "مثال: مدير البنك، السفارة، لمن يهمه الأمر",
    reason: "السبب",
    reasonPlaceholder: "لماذا تحتاج هذا المستند؟",
    submitRequest: "إرسال الطلب",
    requestSalaryAdvancement: "طلب سلفة على الراتب",
    requestedAmount: "المبلغ المطلوب",
    enterAmount: "أدخل المبلغ",
    whyNeedAdvancement: "لماذا تحتاج هذه السلفة؟",
    numberOfInstallments: "عدد الأقساط",
    numberOfInstallmentsPlaceholder: "مثال: 6",
    repaymentStartDate: "تاريخ بدء السداد",
    repaymentPlan: "خطة السداد",
    monthlyInstallments: "قسط شهري بقيمة تقريبية",
    approved: "موافق عليه",
    pending: "قيد الانتظار",
    rejected: "مرفوض",
    completed: "مكتمل",
    disbursed: "تم الصرف",
    processing: "قيد المعالجة",
    low: "منخفض",
    normal: "عادي",
    high: "عالي",
    urgent: "عاجل",
    optional: "(اختياري)",
    required: "*",
    previewFailed: "فشل عرض المستند",
  },
  en: {
    pageTitle: "Employee Self-Service",
    myDocuments: "My Documents",

    myDocumentsDesc:
      "View, manage, and upload all work documents, contracts, and certificates",
    goToDocuments: "Go to Documents",
    solfaRequests: "Salary Advancement Requests",
    solfaRequestsDesc:
      "Request salary advancement and track your advancement requests and active payments",
    goToSolfa: "Go to Advancement",
    storageOverview: "Storage Overview",
    usedStorage: "Used Storage",
    totalFiles: "Total Files",
    storageUsed: "Storage Used",
    used: "Used",
    total: "Total",
    searchPlaceholder: "Search documents, tags, or content...",
    requestDocument: "Request Document",
    upload: "Upload",
    allDocuments: "All Documents",
    contracts: "Contracts",
    payslips: "Payslips",
    certificates: "Certificates",
    policies: "Policies",
    otherCategory: "Other",
    documents: "Documents",
    myRequests: "My Requests",
    noRequestsYet: "No document requests yet",
    requested: "Requested:",
    solfaOverview: "Advancement Overview",
    totalRequests: "Total Requests",
    totalRequested: "Total Requested",
    activeAdvances: "Active Advances",
    outstandingBalance: "Outstanding Balance",
    requestAdvancement: "Request Advancement",
    mySolfaRequests: "My Advancement Requests",
    noSolfaYet: "No advancement requests yet",
    installments: "installment",
    balance: "Balance:",
    uploadNewDocument: "Upload New Document",
    dragDropFiles: "Drag and drop files here",
    orClickBrowse: "or click to browse files",
    browseFiles: "Browse Files",
    documentType: "Document Type",
    contract: "Contract",
    payslip: "Payslip",
    certificate: "Certificate",
    policy: "Policy",
    cancel: "Cancel",
    close: "Close",
    fileSize: "File Size",
    format: "Format",
    uploadDate: "Upload Date",
    status: "Status",
    tags: "Tags",
    viewDocument: "View Document",
    requestHRDocument: "Request HR Document",
    selectDocumentType: "Select Document Type",
    hrLetter: "HR Letter",
    hrLetterDesc: "Official HR letter including employment details",
    bankHRLetter: "Bank HR Letter",
    bankHRLetterDesc:
      "HR letter for banking purposes with salary transfer clause",
    salaryStatement: "Salary Statement",
    salaryStatementDesc:
      "Detailed statement of salary, deductions, and monthly allowances",
    experienceCertificate: "Experience Certificate",
    experienceCertificateDesc:
      "Official certificate proving employment period and job title",
    vacationRequest: "Vacation Request",
    vacationRequestDesc: "Official vacation request with duration and type",
    otherDocument: "Other Document",
    otherDocumentDesc: "Any other document from HR",
    documentDetails: "Document Details",
    documentDetailsPlaceholder: "Describe the document you need in detail...",
    recipient: "Recipient",
    recipientPlaceholder:
      "Example: Bank Manager, Embassy, To Whom It May Concern",
    reason: "Reason",
    reasonPlaceholder: "Why do you need this document?",
    submitRequest: "Submit Request",
    requestSalaryAdvancement: "Request Salary Advancement",
    requestedAmount: "Requested Amount",
    enterAmount: "Enter amount",
    whyNeedAdvancement: "Why do you need this advancement?",
    numberOfInstallments: "Number of Installments",
    numberOfInstallmentsPlaceholder: "Example: 6",
    repaymentStartDate: "Repayment Start Date",
    repaymentPlan: "Repayment Plan",
    monthlyInstallments: "Monthly installment of approximately",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    completed: "Completed",
    disbursed: "Disbursed",
    processing: "Processing",
    low: "Low",
    normal: "Normal",
    high: "High",
    urgent: "Urgent",
    optional: "(Optional)",
    required: "*",
    previewFailed: "Failed to preview document",
  },
};

export default translations;
